module.exports = __webpack_public_path__ + "static/media/mainBannerCurvedSection.7010304c.svg";